import { z } from 'zod';
import { OrgFunctionSchema, OrgFunctionKindSchema } from '../../entities/org-function/org-function.schema';
import { IncludeDeletedRequestSchema } from '../../shared/include-deleted.schema';
/**
 * List OrgFunctions Request Schema
 * GET /api/v2/orgFunction
 *
 * Query parameters:
 * - kind: 'team' | 'role' — optional; omitted returns all kinds.
 */ export const ListOrgFunctionsRequestSchema = IncludeDeletedRequestSchema.extend({
    kind: OrgFunctionKindSchema.optional()
});
/**
 * List item: the OrgFunction plus its derived member count (distinct users
 * linked via mainRole/secondaryRoles — the lead is the responsible person,
 * not a member), computed server-side so clients don't have to mirror the
 * membership rule.
 */ export const ListOrgFunctionsItemSchema = OrgFunctionSchema.extend({
    // Required: the owning endpoint always computes it, so consumers never
    // need a fallback.
    memberCount: z.number()
});
/**
 * List OrgFunctions Response Schema
 * GET /api/v2/orgFunction
 */ export const ListOrgFunctionsResponseSchema = z.object({
    data: z.array(ListOrgFunctionsItemSchema)
});

//# sourceMappingURL=list-org-functions.schema.js.map